const Form003TC = {
    stepName: {
        statement: "重要告示",
        applicationForm: "申請表格",
        schoolInformation: "學校資料",
        confirmation: "確認申請",
        choosePlan: "選擇甲／乙部",
        partA: "甲部",
        partB: "乙部",
    },
    // dealineContent:"",
    label: {
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        iamSmartCondition: "本人理解此電子表格必須由校監使用「智方便+」簽署。",

        choosePlan: {
            formVersion: "请选择合适的申请表版本",
            title1: "本校參加／不參加",
            title2: "「在校免費午膳」計劃（「計劃」） 。",
            planA: "參加",
            planB: "不參加",
            selectionOptions: {
                will: "參加",
                willNot: "不參加",
            },
        },
        partA: {
            errorMsg: {
                maxError: "最大長度為：",
                error1: "如果選擇了其他，請詳細說明",
                error2: "只允許輸入（字母/數字/中文）",
                notTheSame: "（i）和（ii）不能被同時選擇",
                errPriceMsg: "適用學生",
                schoolCode: "此項長度必須為{{length}}位",
                titleCorrespondLang: "中英文的稱謂須相互對應",
            },

            title1: "(1) 本校為學生安排在校午膳的方式是：",
            node: {
                node: "注意",
                note1Normal:
                    "本校會妥善知會家長有關「在校免費午膳」項目，特別是教育局通函第 {{circularNumber}} 號列載為合資格的小學生提供在校免費午膳的參加條款的午膳安排，詳情如下：",
                node1: "本校會妥善知會家長有關「計劃」的詳情，並會為合資格的學生提供在校免費午膳。本校的午膳安排詳情如下： ",
                node2: "（請在適當的方格內加上√號，並填上所需資料。）",
            },
            mode: {
                mode1: `(i) 透過現行招標及采購的程序為學生選擇午膳供應商。`,
                mode2: "(ii) 由學校聘請員工為學生提供午膳。",
                mode3: "(iii) 其他",
            },
            modePlaceHolder: "請簡單說明",
            modeName: "方式",
            title2: ` `,
            firstUnderlineTitle2: "分開",
            beforeFirstUnderlineTitle2:
                "(2) {{schoolYear}} 學年每份學生午膳的定價如下（",
            afterFirstUnderlineTitle2Normal:
                "（例如初小／高小學生），請分別填寫；若只有",
            afterFirstUnderlineTitle2:
                "<i>如不同類別的學生（例如初小／高小學生）的午膳價格不同，請分別填寫；若只有<u>一個</u>午膳價格，請填寫定價 1。</i>",
            secondUnderlineTitle2: "一個",
            afterSecondUnderlineTitle2: "）：",
            afterSecondUnderlineTitle2Normal: "，請填寫定價 1。）：",
            //content1: "",
            content2: `（請根據午膳供應商在合約列明的定價，或因應其他午膳安排模式而知會家長的定價填寫。）`,
            content2Normal:
                "（請根據午膳供應商在合約列明的定價，或因應其他午膳安排模式而知會家長的定價填寫。）",
            price1: "定價1（適用學生）",
            price2: "定價2（適用學生）",
            // price3: "定價3（適用於半日上課安排的餐盒）港幣",
            HKD: "港幣",
            title3: "(3) 預計為學生安排在校免費午膳的日數（<i>午膳日數可不等同於上學日數</i>）：",
            content3: "(i) {{startOfDaysLabel}}（ {{endOfDaysLabel}} ） ：",
            day1: " 日",
            content4: "(ii) {{startOfSecDaysLabel}}{{endOfSecDaysLabel}} ：",
            day2: " 日",
            dayMsg: "數字",
            tooltip1:
                "只適用於教育局宣布小學因疫情必須實行半天面授課堂的情況。",
            tooltip2: "參加學校請填妥甲部，不參加學校請填妥乙部。",
        },
        partB: {
            title: "本校不參加「計劃」，原因如下",
            mainCause: "原因",
            errMsg: "原因",
        },
        certification: "負責教職員姓名",
        telNo: "學校電話號碼",
        fax: "傳真號碼",
        date: "日期",
        deadline: "截止日期",
        circularNumber: "通函編號",
        supervisorName: "校監姓名",
        title: "校監稱謂",
        supervisorNameCN: "校監姓名",
        titleCN: "校監稱謂（中）",
        supervisorNameEN: "校監姓名",
        titleEN: "校監稱謂（英）",
        schoolName: "學校名稱",
        schoolCode: "學校編號",
        email: "學校電郵",
        versionOptions: {
            normal: "普通版",
            special: "疫情特别版",
        },
        titleCNOptions: [
            "先生",
            "女士",
            "小姐",
            "太太",
            "博士",
            "教授",
            "牧師",
            "神父",
            "修女",
            "法師",
            "修士",
        ],
        titleENOptions: [
            "Mr",
            "Ms",
            "Miss",
            "Mrs",
            "Dr",
            "Prof",
            "Rev",
            "Fr",
            "Sr",
            "Ven",
            "Br",
        ],
        supervisorNameErrorMsg: "校監姓名（中）跟校監姓名（英）必须是对应的",
    },
    params: {
        schoolYear: "2021/22",
        circularNumber: "64/2021",
        endOfDaysLabelTc: "官立小學則至2022年3月",
        endOfSecDaysLabelTc: "（官立小學由2022年4月）至7月",
        startOfDaysLabelTc: "2021年9月至12月",
        startOfSecDaysLabelTc: "2022年1月",
    },
    note: {
        note1: `就本學年的「在校免費午膳」申請，本校已知悉有關計劃的安排，並會妥善知會家長相關詳情。`,
    },
};
export default Form003TC;
